import { useState } from 'react';

/**
 * Custom hook to manage pagination and sorting state
 */
const usePaginationAndSorting = (initialSortField = 'estimated_revenue', initialSortDirection = 'desc') => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalItems, setTotalItems] = useState(0);
  const [sortField, setSortField] = useState(initialSortField);
  const [sortDirection, setSortDirection] = useState(initialSortDirection);
  const [allDataFetched, setAllDataFetched] = useState(false);
  
  // Function to handle page change
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    return { page: newPage, rowsPerPage };
  };
  
  // Function to handle rows per page change
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    return { page: 0, rowsPerPage: newRowsPerPage };
  };
  
  // Function to handle sort change
  const handleSortChange = (field) => {
    console.log(`Changing sort to field: ${field}`);
    
    // Set new sort field and direction
    const newDirection = sortField === field ? 
      (sortDirection === 'asc' ? 'desc' : 'asc') : 
      'desc';
      
    setSortField(field);
    setSortDirection(newDirection);
    
    console.log(`Sort updated: ${field} ${newDirection}`);
    
    return { sortField: field, sortDirection: newDirection };
  };
  
  // Reset pagination
  const resetPagination = () => {
    setPage(0);
    setAllDataFetched(false);
  };
  
  // Update total items count
  const updateTotalItems = (total) => {
    setTotalItems(total);
  };
  
  // Check if all data is fetched
  const checkAllDataFetched = (dataLength, total) => {
    const isAllFetched = total && dataLength >= total;
    setAllDataFetched(isAllFetched);
    return isAllFetched;
  };
  
  return {
    page,
    rowsPerPage,
    totalItems,
    sortField,
    sortDirection,
    allDataFetched,
    handlePageChange,
    handleRowsPerPageChange,
    handleSortChange,
    resetPagination,
    updateTotalItems,
    checkAllDataFetched,
    setAllDataFetched
  };
};

export default usePaginationAndSorting; 